const translations = {
    flatRate: 'Flat Rate',
    taxAmount: 'Tax Amount'
};

export default translations;
